import { Button, HStack, Popover, Pressable, Text } from 'native-base';
import { useState } from 'react';

import { colors } from '../../theme/colors';
import Icon from '../Icon/';
import { styles } from './styles';
import { IOptions, IPopOverOptions } from './types';

export const PopOverOptions = ({
  customButton,
  customButtomStyles,
  options,
  popovText,
  popovTextPosition = 'left',
  popTextColor = colors.darkText,
  popovIcon = 'more-horizontal',
  popovIconColor = colors.darkText,
  placement = 'bottom',
}: IPopOverOptions) => {
  const [showPopOver, setShowPopOver] = useState<boolean>(false);
  const [currentSubmenu, setCurrentSubmenu] = useState<IOptions[] | null>(null);

  const handleShowPopOver = (show: boolean) => {
    setShowPopOver(show);
    if (!show) {
      setCurrentSubmenu(null);
    }
  };

  const handleOptionClick = (option: IOptions) => {
    if (option.submenu) {
      setCurrentSubmenu(option.submenu);
    } else {
      handleShowPopOver(false);
      if (option.action) option.action();
    }
  };

  const handleBackToMainMenu = () => {
    setCurrentSubmenu(null);
  };

  return (
    <Popover
      isOpen={showPopOver}
      placement={placement}
      useRNModal
      trigger={(triggerOptions) => (
        <Button
          {...customButtomStyles}
          {...triggerOptions}
          variant="link"
          fontSize="14px"
          fontWeight={500}
          w="fit-content"
          onPress={() => handleShowPopOver(true)}
        >
          <HStack justifyContent="center" alignItems="center">
            {customButton || (
              <HStack space={1} alignItems="center">
                {popovText && popovTextPosition === 'left' ? (
                  <Text color={popTextColor} fontSize="xs" fontWeight={500}>
                    {popovText}
                  </Text>
                ) : null}
                <Icon icon={popovIcon} color={popovIconColor} size={20} />
                {popovText && popovTextPosition === 'right' ? (
                  <Text color={popTextColor} fontSize="xs" fontWeight={500}>
                    {popovText}
                  </Text>
                ) : null}
              </HStack>
            )}
          </HStack>
        </Button>
      )}
      onClose={() => handleShowPopOver(false)}
    >
      <Popover.Content w="56" mt={4} borderRadius={16}>
        <Popover.Body p={0} py={2}>
          {currentSubmenu ? (
            <>
              {/* Botão de voltar */}
              <Pressable onPress={handleBackToMainMenu} p={3}>
                <HStack space={3} alignItems="center">
                  <Icon icon="arrow-left" size={22} color={colors.gray[600]} />
                  <Text color={colors.gray[600]} fontSize="md">
                    Back
                  </Text>
                </HStack>
              </Pressable>
              {/* Opções do submenu */}
              {currentSubmenu.map((option) => (
                <Pressable
                  key={option.title}
                  onPress={() => handleOptionClick(option)}
                  p={3}
                >
                  <HStack space={3} alignItems="center">
                    {option.icon ? (
                      <Icon
                        icon={option.icon.icon}
                        size={option.icon.size}
                        color={option.icon.color}
                        isCustom={option.icon.isCustom}
                      />
                    ) : null}
                    <Text
                      color={option.titleColor || colors.gray[600]}
                      fontSize="md"
                    >
                      {option.title}
                    </Text>
                  </HStack>
                </Pressable>
              ))}
            </>
          ) : (
            <>
              {/* Menu principal */}
              {options.map((option) => (
                <HStack
                  alignItems="center"
                  justifyContent="flex-start"
                  key={option.title}
                  p={2}
                >
                  {option.icon ? (
                    <Icon
                      icon={option.icon.icon}
                      size={option.icon.size}
                      color={option.icon.color}
                      isCustom={option.icon.isCustom}
                    />
                  ) : null}
                  {option.link ? (
                    <a
                      style={styles.link}
                      href={option.link.href}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Text>{option.title}</Text>
                    </a>
                  ) : (
                    <Button
                      variant="link"
                      w="fit-content"
                      onPress={() => handleOptionClick(option)}
                    >
                      <Text color={option.titleColor || 'darkText'}>
                        {option.title}
                      </Text>
                    </Button>
                  )}
                </HStack>
              ))}
            </>
          )}
        </Popover.Body>
      </Popover.Content>
    </Popover>
  );
};
